import { render, staticRenderFns } from "./HowItWorksNew.vue?vue&type=template&id=89ac5be2&scoped=true"
import script from "./HowItWorksNew.vue?vue&type=script&lang=js"
export * from "./HowItWorksNew.vue?vue&type=script&lang=js"
import style0 from "./HowItWorksNew.vue?vue&type=style&index=0&id=89ac5be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ac5be2",
  null
  
)

export default component.exports